var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE02A795-43FD-4DCE-AEEB-6A32DC10FFA6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-444.000000, -107.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(444.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15 C30,23.2842944 23.2842944,30 15,30 C6.71570565,30 0,23.2842944 0,15 C0,6.71570565 6.71570565,0 15,0 C23.2842944,0 30,6.71570565 30,15 Z M13.2649597,22.942379 L24.3939919,11.8133468 C24.7718952,11.4354435 24.7718952,10.8226815 24.3939919,10.4447782 L23.0254234,9.07620968 C22.6475202,8.69824597 22.0347581,8.69824597 21.6567944,9.07620968 L12.5806452,18.1522984 L8.34320565,13.9148589 C7.96530242,13.5369556 7.35254032,13.5369556 6.97457661,13.9148589 L5.60600806,15.2834274 C5.22810484,15.6613306 5.22810484,16.2740927 5.60600806,16.651996 L11.8963306,22.9423185 C12.2742944,23.3202823 12.886996,23.3202823 13.2649597,22.942379 L13.2649597,22.942379 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.1908fda7afa2fb9600c4ebbbe51f647e.svg";
export { ForwardRef as ReactComponent };